import * as React from 'react';
import createSvgIcon from './utils/createSvgIcon';
export default createSvgIcon( /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
  d: "M9 14.14V9.86L5.97 12zm9 0V9.86L14.97 12z",
  opacity: ".3"
}), /*#__PURE__*/React.createElement("path", {
  d: "M11 6l-8.5 6 8.5 6V6zm-2 8.14L5.97 12 9 9.86v4.28zM20 6l-8.5 6 8.5 6V6zm-2 8.14L14.97 12 18 9.86v4.28z"
})), 'FastRewindTwoTone');


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/icons/esm/FastRewindTwoTone.js
// module id = 3513
// module chunks = 2